import {
  GET_CUSTOM_CONTACTS_REQUEST,
  GET_CUSTOM_CONTACTS_SUCCESS,
  GET_CUSTOM_CONTACTS_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  total: 0,
  security: {},
  status: statusType.IDLE,
  initialLoading: true
}

const contacts = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case GET_CUSTOM_CONTACTS_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CUSTOM_CONTACTS_SUCCESS:
      return {
        data: payload.data,
        total: payload.total,
        security: payload.security,
        status: statusType.SUCCESS,
        initialLoading: false
      }

    case GET_CUSTOM_CONTACTS_FAILURE:
      return {
        ...state,
        status: statusType.ERROR,
        initialLoading: false
      }

    default:
      return state
  }
}

export default contacts